import React from 'react'

function PlanFlagsTab({ plan }) {
  const flags = plan?.flags || {}

  return (
    <div>
      <h4 style={{ fontSize: '1rem', marginBottom: '0.5rem' }}>🚩 Plan Flags</h4>
      {Object.keys(flags).length > 0 ? (
        <ul style={{ paddingLeft: 0, listStyle: 'none' }}>
          {Object.entries(flags).map(([key, value]) => (
            <li key={key} style={{ marginBottom: '0.5rem' }}>
              <strong>{key.replace(/_/g, ' ')}:</strong> {String(value) || '—'}
            </li>
          ))}
        </ul>
      ) : (
        <p>None</p>
      )}
    </div>
  )
}

export default PlanFlagsTab
